module.exports = __webpack_public_path__ + "img/logo.51ab6e37.png";